import * as z from "zod";
import { assertCanChangeLiveness } from "./livenessGate";
import { mutator } from "./mutator";

export const deleteWorkflow = mutator({
  schema: z.object({ workflowId: z.string() }),
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args: { workflow } }) => {
    await assertCanChangeLiveness(tx, ctx, workflow);
    await tx.mutate.workflows.update({
      id: workflow.id,
      deletedAt: Date.now(),
    });
  },
});
